module.exports = __webpack_public_path__ + "files/a059b6048d414d4633c862fb24297950.png";